module.exports = __webpack_public_path__ + "static/media/safeguarding.c0058756.jpeg";